// Empty function component
const ThemeBackground = () => null;
export default ThemeBackground;
